import React from 'react'

const GitLabSVG = React.memo(() => {
  return (
    React.createElement('svg', {
      version: "1.1",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"   ,
      xmlns: "http://www.w3.org/2000/svg",}

      , React.createElement('path', {
        d: "M23.6 9.149l-.033-.086L20.3.538a.851.851 0 0 0-.844-.535.875.875 0 0 0-.492.184.875.875 0 0 0-.29.44L16.47 7.374H7.537L5.332.626a.857.857 0 0 0-.29-.44.875.875 0 0 0-1-.054.859.859 0 0 0-.336.404L.433 9.058l-.032.086a6.066 6.066 0 0 0 2.012 7.01l.01.01.03.02 4.977 3.727 2.462 1.863 1.5 1.133a1.009 1.009 0 0 0 1.22 0l1.499-1.133 2.462-1.863 5.006-3.749.012-.01a6.068 6.068 0 0 0 2.01-7.003z"                                              ,
        fill: "#E24329",}
      )
      , React.createElement('path', {
        d: "M23.6 9.149l-.033-.086c-1.592.326-3.092 1-4.393 1.974L12 16.462c2.443 1.848 4.57 3.454 4.57 3.454l5.006-3.75.013-.01A6.069 6.069 0 0 0 23.6 9.15z"               ,
        fill: "#FC6D26",}
      )
      , React.createElement('path', {
        d: "M7.43 19.916l2.462 1.863 1.5 1.132a1.009 1.009 0 0 0 1.22 0l1.5-1.132 2.461-1.863-4.572-3.454c-2.443 1.843-4.57 3.454-4.57 3.454z"              ,
        fill: "#FCA326",}
      )
      , React.createElement('path', {
        d: "M4.824 11.038a11.02 11.02 0 0 0-4.39-1.98L.4 9.144a6.066 6.066 0 0 0 2.012 7.01l.01.01.03.02 4.977 3.727L12 16.457l-7.176-5.42z"               ,
        fill: "#FC6D26",}
      )
    )
  )
})

export default GitLabSVG
